import { Component, Vue } from 'vue-property-decorator'
import { JtCompositionFormModal, JtDynamicForm } from 'jtech-webcomps'
import {
  QDialog,
  QLayout,
  QIcon,
  QToolbar,
  QToolbarTitle,
  QHeader,
  QBtn
} from 'quasar'

@Component({
  mixins: [JtCompositionFormModal],
  name: 'CompositionMultiFormModal',
  components: {
    JtDynamicForm,
    QDialog,
    QLayout,
    QIcon,
    QToolbar,
    QHeader,
    QToolbarTitle,
    QBtn
  },
  props: {
    cssname: {
      type: String,
      default: () => {
        return 'composition-multi-form-modal'
      }
    },
    titleTopBar: {
      type: String,
      required: true
    },
    addOneMoreItemButtonLabel: {
      type: String,
      required: true
    },
    beforePerformItems: {
      type: Function,
      required: false
    },
    afterPerformItems: {
      type: Function,
      required: false
    },
    flMainCrudInChange: {
      type: Boolean,
      required: true
    },
    nonChangeableFields: {
      type: Array,
      required: false
    }
  }
})
class CompositionMultiFormModal extends Vue {
  listForms = []

  prepareInputs (inputs) {
    inputs.forEach(input => {
      if (this.flComposicaoAlteracao && this.flMainCrudInChange && this.nonChangeableFields.includes(input.model)) {
        input.readonly = true
      }
    })

    return inputs
  }

  show () {
    this.listForms = []
    this.addItem()
    this.$refs.jtCompositionModal.show()
  }

  addItem () {
    this.listForms.push({ ...this.form.dadosForm })
  }

  dropItem (index) {
    this.listForms.splice(index, 1)

    if (this.listForms.length === 0) {
      this.addItem()
    }
  }

  getButtonColor (type, nmButton) {
    switch (type.toUpperCase()) {
      case 'SUBMIT':
        return 'info'
      case 'CANCEL':
        return 'grey-7'
      case 'RESET':
        return 'warning'
      case 'DELETE':
        return 'negative'
      default:
        return this.getCustomButtonColor(nmButton)
    }
  }

  getCustomButtonColor (nmButton) {
    switch (nmButton) {
      case 'btLimparComposicao':
        return 'grey-7'
      default:
        return 'light'
    }
  }

  getButtonClasses (index) {
    const isFirstIndex = index === 0
    const defaultClass = 'q-px-xl'
    const notFirstButtonClass = isFirstIndex ? ' ' : 'q-ml-lg'

    return `${defaultClass} ${notFirstButtonClass}`
  }

  onFormButtonClickHandler (clickedButton) {
    switch (clickedButton.name) {
      case 'btSalvarComposicao':
        this.btSalvarComposicao()
        break
      case 'btLimparComposicao':
        this.clearMultForm()
        break
      default:
        break
    }
  }

  async btSalvarComposicao () {
    try {
      if (this.isAllFormsValid()) {
        const preparedItems = await this.prepareItems()

        this.performActionOnTheComposition(preparedItems)
      }
    } catch (error) {
      this.displayOnConsoleError(error)
    }
  }

  isAllFormsValid () {
    let valid = true

    this.listForms.forEach((item, index) => {
      if (this.$refs[`itemForm-${index}`][0].isValidForm() === false) {
        valid = false
      }
    })

    return valid
  }

  async prepareItems () {
    const preparedItems = []

    for (const item of this.listForms) {
      const preparedItem = await this.prepareItem(item)
      preparedItems.push(preparedItem)
    }

    return preparedItems
  }

  async prepareItem (item) {
    const params = {
      method: 'salvarComposicao',
      composicaos: this.composicaos,
      flComposicaoAlteracao: this.flComposicaoAlteracao,
      ...item,
      available: true,
      nrLinhaSelecionada: this.nrLinhaSelecionada
    }

    return await this.prepareItemInTheFramework(params)
  }

  async prepareItemInTheFramework (params) {
    try {
      const { nmInterface } = this.form

      const {
        data: { dadosGrid }
      } = await this.$jt.repository.manterComponente(nmInterface, params)
      return dadosGrid
    } catch (error) {
      const message =
        'Error within the \'prepareItemToAddComposition\' method ' +
        'when executing \'this.$jt.repository.manterComponente\''
      throw this.formatError(message, error)
    }
  }

  async performActionOnTheComposition (preparedItems) {
    if (this.beforePerformItems) {
      await this.beforePerformItems(preparedItems)
    }

    if (this.flComposicaoAlteracao) {
      this.editCompositionItem(preparedItems[0])
    } else {
      this.addItemsToComposition(preparedItems)
    }

    if (this.afterPerformItems) {
      await this.afterPerformItems(preparedItems)
    }
  }

  editCompositionItem (preparedItem) {
    Object.assign(this.composicaos[this.nrLinhaSelecionada], preparedItem)

    this.composicaos[this.nrLinhaSelecionada].flAlterado = true
  }

  addItemsToComposition (preparedItems) {
    let compositionIdx = this.composicaos.length

    preparedItems.forEach(preparedItem => {
      preparedItem.flAlterado = 'N'
      preparedItem.__index = compositionIdx
      compositionIdx++
    })

    this.composicaos.push(...preparedItems)
  }

  async executeAsAPromisse (method, params) {
    if (method.then) {
      await method(params)
    } else {
      method(params)
    }
  }

  clearMultForm () {
    this.listForms = []
    this.addItem()
  }

  formatError (message, erorStack) {
    return {
      errorCompositionMultiFormModal: {
        message,
        erorStack
      }
    }
  }

  displayOnConsoleError (error) {
    if (error.errorCompositionMultiFormModal) {
      const { message, errorStack } = error.errorCompositionMultiFormModal
      console.error(message)
      throw errorStack
    } else {
      throw error
    }
  }
}
export default CompositionMultiFormModal
